import BlogCard from 'components/BlogCard';
import Footer from 'components/Footer';
import React from 'react';

interface BlogsProps {
  showFooter?: boolean;
  limit?: number;
}

const Blogs: React.FC<BlogsProps> = ({ showFooter = true, limit }) => {
  return (
    <div>
      <BlogCard limit={limit} />
      {showFooter && <Footer />}
    </div>
  );
};

export default Blogs;
